export class Files {
  createdAt?: string;
  id?: string;
  name?: string;
  size?: string;
  updatedAt?: string;
  url?: string;

  constructor(item: any) {
    this.id = item.id;
    this.name = item.name;
    this.size = item.size;
    this.updatedAt = item.updatedAt;
    this.url = item.url;
  }
}
